import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "./AppOverlay";
import "./UnsavedChangesDialog.scss";

const UnsavedChangesDialog = ({
  isOpen,
  onContinue,
  onDiscard,
  onDiscardAndClose,
  subject = "details",
  title = "Discard changes?",
  message,
  confirmLabel = "Discard changes",
  confirmColor = "danger",
  discardAndCloseLabel = "Discard and close",
}) => (
  <Modal
    className={`unsaved-changes-dialog${
      onDiscardAndClose ? " unsaved-changes-dialog--three-actions" : ""
    }`}
    centered
    isOpen={isOpen}
    toggle={onContinue}
  >
    <ModalHeader toggle={onContinue}>{title}</ModalHeader>
    <ModalBody>
      {message || (
        <>
          You have unsaved {subject}. If you close this form, the entered
          information will be lost.
        </>
      )}
    </ModalBody>
    <ModalFooter>
      <Button outline onClick={onContinue}>
        Continue editing
      </Button>
      {onDiscardAndClose && (
        <Button color="danger" outline onClick={onDiscardAndClose}>
          {discardAndCloseLabel}
        </Button>
      )}
      <Button color={confirmColor} onClick={onDiscard}>
        {confirmLabel}
      </Button>
    </ModalFooter>
  </Modal>
);

export default UnsavedChangesDialog;
